<app-message-preview [isActive]="true"></app-message-preview>
<app-message-preview></app-message-preview>
